import React, { Component, useEffect, useMemo, useState } from 'react';

import CreatableSelect from 'react-select/creatable';
import { ActionMeta, components, OnChangeValue } from 'react-select';
import DropdownIcon from "../../assets/images/faq/btn/down_arrow.svg";
import ClearIcon from "../../assets/images/del/delete.svg";

const CreateSelect = ({options, loading, initialValues, formik, searchable, field, form, placeholder}) => {
    const onChange = (option) => {
      form.setFieldValue(field.name, option?.value.trim());
      formik.values[field.name] = option?.value;
      // console.log(formik.values, "field name");

    };

    const getValue = () => {
      if(initialValues.gname !== "" && initialValues.country !== "") {
        // console.log(initialValues, "values");
        return ({ label: initialValues[field.name], value: initialValues[field.name]});
      } else if (options.length > 0) {
        const result = options.find(option => option.value === field.value);
        return result;
      } else {
        return null;
      }
    };


  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator style={{padding: "0 !important"}} {...props}>
          <img style={{marginLeft: "0.5rem", width: "3rem"}} src={DropdownIcon} />

      </components.DropdownIndicator>
    );
  };

  const ClearIndicator = props => {
    return (
      <components.ClearIndicator {...props}>
        <img style={{width: "3.5rem"}} src={ClearIcon} />
      </components.ClearIndicator>
    );
  };

  const customStyles = () => ({
    menu: (provided, state) => ({
      ...provided,
      border: "1px solid #e2e2e2",
      marginTop: "-0.5rem",
      background: "#fff",
      borderRadius: "0 0 3rem 3rem",
      overflow: "hidden"
    }),

    control: (provided, state) => ({
      ...provided,
      background: "#13320C",
      padding: "1.2rem 0.5rem 1.2rem 4rem",
      borderRadius: state.menuIsOpen ? "3rem 3rem 0 0" : "4rem",
      fontFamily: "Jost",
      fontSize: "2rem",
      fontWeight: "600",
      border: 0,
      boxShadow: 0,
      color: "white"
    }),

    placeholder: (provided, state) => ({
      ...provided,
      color: "grey",
      fontFamily: "Jost",
      fontSize: "2.2rem",
      textTransform: "UpperCase"
    }),

    option: (provided, state) => ({
      ...provided,
      color:  "black",
      padding: "1.3rem 1.9rem 1.2rem",
      fontSize: "16px",
      fontWeight: "500",
      borderBottom: "1px solid #ccc"
    }),

    singleValue: (provided, state) => ({
      ...provided,
      color: "white",
    }),

    input: (provided, state) => ({
      ...provided,
      color: "white",
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: "0 1rem",
    }),

  });

    return (
      <CreatableSelect
        isClearable
        onChange={onChange}
        name={field.name}
        components = {{ DropdownIndicator }}
        value={getValue()}
        options={options}
        styles={customStyles()}
        placeholder={placeholder}
        isSearchable={searchable}
        isLoading={loading}
      />
    );
}

export default CreateSelect;
